/* styles/tiles.js */ function _(require, module, exports) {
    require(62) /* ./root */;
    const _a = require(61) /* ../core/dom */;
    _a.styles.append(".bk-root .bk-tile-attribution a {\n  color: black;\n}\n");
    exports.bk_tile_attribution = "bk-tile-attribution";
}
